import { Form, Tabs } from 'antd';
import { memo } from 'react';

import { CurrencyWrapper } from 'app/components/commons/Currency/CurrencyWrapper/CurrencyWrapper';
import { useGetHotel } from 'app/hooks/data/hotels/useHotel';

import { MenuItemName } from '../menuItem';

import { Access } from './Accessibility/Access';
import { Limitations } from './Accessibility/Limitations';
import { Schedule } from './Accessibility/Schedule';
import { Availability } from './Availability/Availability';
import { BasicInformations } from './BasicInformations/BasicInformations';
import { Copywriting } from './Copywriting/Copywriting';
import { Medias } from './Medias/Medias';

export const ExperienceForm = memo(
  ({ itemName }: { itemName: MenuItemName }) => {
    const form = Form.useFormInstance();
    const hotelId = Form.useWatch(['hotelId'], form);
    const countryId = Form.useWatch(['countryId'], form);

    const { data: hotel } = useGetHotel(hotelId);

    const tabs = [
      {
        key: MenuItemName.General,
        label: 'General',
        children: <BasicInformations />,
      },
      {
        key: MenuItemName.Accessibility,
        label: 'Accessibility',
        children: (
          <>
            <Access />
            <Schedule />
            <Limitations />
          </>
        ),
      },
      {
        key: MenuItemName.Availability,
        label: 'Availability & Prices',
        children: <Availability />,
      },
      {
        key: MenuItemName.Copywriting,
        label: 'Copywriting',
        children: <Copywriting />,
      },
      {
        key: MenuItemName.Medias,
        label: 'Medias',
        children: <Medias />,
      },
    ];

    return (
      <CurrencyWrapper hotel={hotel} countryId={countryId}>
        <Tabs
          activeKey={itemName}
          onChange={() => null}
          renderTabBar={() => <></>}
          items={tabs}
        />
      </CurrencyWrapper>
    );
  }
);

ExperienceForm.displayName = 'ExperienceForm';
